/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import { useNuxtApp } from 'nuxt/app';
import type Rollbar from 'rollbar';

export interface UseRollbarReturn {
	logError: (...args: unknown[]) => void;
	logWarning: (...args: unknown[]) => void;
	logInfo: (...args: unknown[]) => void;
}

export const useRollbar = (): UseRollbarReturn => {
	const { $rollbar } = useNuxtApp();

	const getRollbarInstance = (): Rollbar | null => {
		return $rollbar ? ($rollbar as Rollbar) : null;
	};

	const logError = (...args: unknown[]): void => {
		const rollbar = getRollbarInstance();
		if (!rollbar) return;

		rollbar.error(args);
	};

	const logWarning = (...args: unknown[]): void => {
		const rollbar = getRollbarInstance();
		if (!rollbar) return;

		rollbar.warning(args);
	};

	const logInfo = (...args: unknown[]): void => {
		const rollbar = getRollbarInstance();
		if (!rollbar) return;

		rollbar.info(args);
	};

	return {
		logError,
		logWarning,
		logInfo,
	};
};
